import { normalizeCoordinateValue, extractDeliveryAddressParts } from "../../utils/delivery";

const NOMINATIM_ENDPOINT = "https://nominatim.openstreetmap.org/search";

export const resolveCoordinates = async (addressString) => {
  const normalized = String(addressString || "").trim();
  if (!normalized) return null;

  const response = await fetch(
    `${NOMINATIM_ENDPOINT}?format=jsonv2&limit=1&q=${encodeURIComponent(normalized)}`,
    { headers: { Accept: "application/json" } }
  );
  if (!response.ok) throw new Error("No fue posible consultar las coordenadas.");
  const results = await response.json();
  const firstResult = Array.isArray(results) ? results[0] : null;
  if (!firstResult?.lat || !firstResult?.lon) throw new Error("No se encontraron coordenadas.");

  return {
    lat: normalizeCoordinateValue(firstResult.lat),
    lng: normalizeCoordinateValue(firstResult.lon),
    address: extractDeliveryAddressParts(firstResult.address),
  };
};